// Order or billing currecy
export const ALL_CURRENCIES = [
    'usd',
    'aed',
    'aud',
    'cad',
    'eur',
    'gbp',
    'nzd',
    'sar',
    'inr',
    'qar',
];
export const DEFAULT_CURRENCY = 'usd';
// Site language
export const ALL_LANGUAGES = ['en', 'de', 'fr', 'es', 'it', 'pt']; //languages added here are used for supportedLngs in i18n init
export const DEFAULT_LANGUAGE = 'en';
// Country or group of countries that can be shipped to (may be deprecated)
export const ALL_REGIONS = [
    'US',
    'AE',
    'AU',
    'CA',
    'EU',
    'NZ',
    'QA',
    'SA',
    'UK',
    'IN',
    // "Rest of World" - countries outside of US paying in USD
    'BH', // Bahrain
    'HK', // Hong Kong
    // 'IL', // Israel - currently not supported but will be supported in future
    'JP', // Japan
    'KR', // South Korea
    'KW', // Kuwait
    'SG', // Singapore
    'TW', // Taiwan
    'ZA', // South Africa
    'MX', // Mexico
];
export const DEFAULT_REGION = 'US';
// Billing region / checkout_origin in the memberships table
export const ALL_BILLING_REGIONS = [
    'domestic', // in US / paying in USD
    'australia',
    'ca', // in Canada / paying in CAD
    'international', // in EU / paying in  EUR
    'nz',
    'sa', // in Saudi Arabia / paying in Riyal
    'uae',
    'uk',
    'in', // in India / paying in INR
    'qa', // in Qatar / paying in QAR
];
export const DEFAULT_BILLING_REGION = 'domestic';
export const DEFAULT_LOCALE = `${DEFAULT_LANGUAGE}-${DEFAULT_REGION}`;
export const RegionCurrencyDetails = [
    { region: 'US', displayName: 'US', currency: '$USD' },
    { region: 'AU', displayName: 'AU', currency: '$AUD' },
    { region: 'CA', displayName: 'CA', currency: '$CAD' },
    { region: 'EU', displayName: 'EU', currency: '€EUR' },
    { region: 'UK', displayName: 'UK', currency: '£GBP' },
    { region: 'NZ', displayName: 'NZ', currency: '$NZD' },
    { region: 'AE', displayName: 'AE/QA', currency: 'AED' },
    { region: 'SA', displayName: 'SA', currency: 'SAR' },
    { region: 'BH', displayName: 'BH', currency: '$USD' },
    { region: 'HK', displayName: 'HK', currency: '$USD' },
    { region: 'IL', displayName: 'IL', currency: '$USD' },
    { region: 'IN', displayName: 'IN', currency: '$USD' },
    { region: 'JP', displayName: 'JP', currency: '$USD' },
    { region: 'KR', displayName: 'KR', currency: '$USD' },
    { region: 'KW', displayName: 'KW', currency: '$USD' },
    { region: 'MX', displayName: 'MX', currency: '$USD' },
    { region: 'SG', displayName: 'SG', currency: '$USD' },
    { region: 'TW', displayName: 'TW', currency: '$USD' },
    { region: 'ZA', displayName: 'ZA', currency: '$USD' },
];
